import {
  Directive,
  ElementRef,
  Renderer2,
  DOCUMENT,
  inject
} from '@angular/core';

@Directive({
  selector: '[bpAddRtlClass]',
  standalone: false
})
export class AddRtlClassDirective {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);
  private document = inject(DOCUMENT);

  constructor() {
    const el = this.el;
    const renderer = this.renderer;

    if (this.document.dir === 'rtl') {
      renderer.addClass(el.nativeElement, 'bp-rtl');
    }
  }
}
